import React from 'react';
import './VisualizationPlaceholder.css';

export default () => {
  return (
    <div className="VisualizationPlaceholder">
      <div className="VisualizationPlaceholder__Title" />
      <div className="VisualizationPlaceholder__Content" />
    </div>
  );
};
